import { z } from '../utils/zod.js';
import { planCodeSchema, planIntervalSchema, usageMeterSchema } from '../pricing-catalogue.js';
import { adminOrganizationCompactSchema } from './compact.js';
import { adminBooleanQuerySchema, adminPageResponse, adminPaginationQuerySchema } from './pagination.js';
export const ADMIN_ORGANIZATION_EXPORT_LIMIT = 5000;
export const ADMIN_ORGANIZATION_SORTS = ['createdAt', 'name', 'planCode', 'usage'];
export const ADMIN_SORT_DIRECTIONS = ['asc', 'desc'];
export const adminOrganizationFiltersSchema = z.object({
    planCode: planCodeSchema.optional(),
    customerType: z.enum(['BUSINESS', 'CONSUMER']).optional(),
    billingExempt: adminBooleanQuerySchema.optional(),
    country: z.string().trim().min(2).max(2).toUpperCase().optional(),
    q: z.string().trim().min(1).max(255).optional().openapi({ description: 'Name or tax id contains' }),
    atRisk: adminBooleanQuerySchema.optional().openapi({
        description: 'Non-exempt paid organizations that used at least 80% of an allowance this period',
    }),
    sort: z
        .enum(ADMIN_ORGANIZATION_SORTS)
        .default('createdAt')
        .openapi({ description: 'usage orders by the number of recorded usage events' }),
    direction: z.enum(ADMIN_SORT_DIRECTIONS).default('desc'),
});
export const adminListOrganizationsQuerySchema = adminPaginationQuerySchema.merge(adminOrganizationFiltersSchema);
export const adminOrganizationMeterUsageSchema = z.object({
    meter: usageMeterSchema,
    used: z.number().int(),
    included: z.number().int().nullable().openapi({ description: 'null = unlimited' }),
});
export const adminOrganizationListItemSchema = adminOrganizationCompactSchema.extend({
    createdAt: z.string().datetime(),
    customerType: z.enum(['BUSINESS', 'CONSUMER']),
    planInterval: planIntervalSchema.nullable(),
    billingExempt: z.boolean(),
    stripeSubscriptionStatus: z.string().nullable(),
    membersCount: z.number().int(),
    signingsCount: z.number().int(),
    usage: z.array(adminOrganizationMeterUsageSchema),
    contractEndsAt: z.string().datetime().nullable(),
});
export const adminListOrganizationsResponseSchema = adminPageResponse(adminOrganizationListItemSchema);
